import { config } from '@/common/config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AuthResponse, LoginDto } from './types.api';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
  }),
  endpoints: (builder) => ({
    // авторизация basic
    login: builder.query<AuthResponse, LoginDto>({
      query: (data) => ({
        url: 'auth',
        headers: {
          accept: 'application/json, text/plain, */*',
          'content-Type': 'application/json',
          authorization: `Basic ${btoa(`${data.login}:${data.password}`)}`,
        },
      }),
    }),
  }),
});
